import React from 'react';

import {
  arrayOf, bool, func, shape, string,
} from 'prop-types';
import {
  Button,
  Container,
  Content,
  Dialog,
  Text,
} from './styles';

const WarningModal = ({ show, onClose, errors }) => (
  <Container
    active={show}
    onClickOutside={onClose}
    page
  >
    <Dialog>
      <Content>
        <Text margin>
          Before you submit this study, please fix the following:
        </Text>

        {errors.map((errorMessage) => (
          <Text key={errorMessage.key}>
            {`- ${errorMessage.message}`}
          </Text>
        ))}
      </Content>

      <Button onClick={onClose}>
        OK
      </Button>
    </Dialog>
  </Container>
);

WarningModal.propTypes = {
  onClose: func.isRequired,
  errors: arrayOf(
    shape({
      key: string,
      message: string,
    }),
  ).isRequired,
  show: bool.isRequired,
};

export default WarningModal;
